import React from 'react'
import ID from './ID'
import styles from './index.module.less'
import NationalEmblem from 'assets/national-emblem.png'

export default function Index() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <div className={styles.img}></div>
        <div className={styles.tips}></div>
      </div>
      <div className={styles.login}>
        <div className={styles.title} />
        <p className={styles.titleName}>密码登录</p>
        <ID />
      </div>
      <div className={styles.footer}>
        <a
          rel="noreferrer"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index">
          渝ICP备17015694号-1
        </a>
        <img src={NationalEmblem} alt="" />
        <a
          rel="noreferrer"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010302003022">
          渝公网安备50010302003022号
        </a>
      </div>
    </div>
  )
}
